import * as DropdownMenu from "@radix-ui/react-dropdown-menu"

export default function DownloadOptionsDropdown({
  label,
  s3key,
  locale,
}: {
  label: string
  s3key: string
  locale?: string
}) {
  return (
    <DropdownMenu.Root key={s3key}>
      <DropdownMenu.Trigger asChild>
        {locale === "en-CA" ? (
          <button className="ml-6 rounded-full bg-brand-green px-6 py-2 text-base text-white transition-all duration-500 hover:bg-brand-green-dark sm:text-xl">
            Download Data
          </button>
        ) : (
          <button className="text-left capitalize text-gray-700 no-underline hover:text-brand-green">
            {label}
          </button>
        )}
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className="min-w-[150px] rounded-lg bg-white shadow-lg">
          <p className="captialize px-2 pt-2 font-bold text-gray-700">{label}</p>
          <div className="border-t border-gray-700" />
          <DropdownMenu.Item className="DropdownMenuItem">
            <a
              className="p-2 text-gray-700 no-underline hover:text-brand-green"
              download
              href={`https://tes-app-data-share.s3.amazonaws.com/${s3key}/${s3key}_shp.zip`}
            >
              Shapefile
            </a>
          </DropdownMenu.Item>
          <div className="border-t border-gray-500" />
          <DropdownMenu.Item className="DropdownMenuItem">
            <a
              className="p-2 text-gray-700 no-underline hover:text-brand-green"
              download
              href={`https://tes-app-data-share.s3.amazonaws.com/${s3key}/${s3key}_geojson.zip`}
            >
              GeoJSON
            </a>
          </DropdownMenu.Item>
          <div className="border-t border-gray-500" />
          <DropdownMenu.Item className="DropdownMenuItem">
            <a
              className="p-2 text-gray-700 no-underline hover:text-brand-green"
              download
              href={`https://tes-app-data-share.s3.amazonaws.com/${s3key}/${s3key}_csv.zip`}
            >
              CSV
            </a>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}
